/**
 * Formats a number with Swiss thousand separator (apostrophe)
 * Example: 300000 -> 300'000
 */
export const formatNumberSwiss = (value: number | string | undefined | null): string => {
  if (value === undefined || value === null || value === '') {
    return '';
  }

  const numValue = typeof value === 'string' ? parseFloat(value) : value;

  if (isNaN(numValue)) {
    return '';
  }

  // Split into integer and decimal parts
  const parts = numValue.toString().split('.');
  const integerPart = parts[0];
  const decimalPart = parts[1];

  // Add apostrophe every 3 digits from the right
  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, "'");

  // Return with decimal part if it exists
  return decimalPart !== undefined ? `${formattedInteger}.${decimalPart}` : formattedInteger;
};

/**
 * Removes Swiss formatting from a string to get a plain number
 * Example: 300'000 -> 300000
 */
export const parseSwissNumber = (value: string): number => {
  if (!value) {
    return 0;
  }

  // Remove all apostrophes and parse
  const cleaned = value.replace(/'/g, '');
  const parsed = parseFloat(cleaned);

  return isNaN(parsed) ? 0 : parsed;
};
